import { format, formatDistanceToNowStrict, isPast, isToday } from "date-fns";

export function formatDate(d, fmt = "dd MMM yyyy") {
  if (!d) return "—";
  try {
    return format(new Date(d), fmt);
  } catch {
    return "—";
  }
}

export function formatDateTime(d) {
  if (!d) return "—";
  try {
    return format(new Date(d), "dd MMM yyyy, h:mm a");
  } catch {
    return "—";
  }
}

export function relTime(d) {
  if (!d) return "";
  try {
    return formatDistanceToNowStrict(new Date(d), { addSuffix: true });
  } catch {
    return "";
  }
}

export function dueColor(d) {
  if (!d) return "text-muted-foreground";
  const date = new Date(d);
  if (isPast(date) && !isToday(date)) return "text-red-600 dark:text-red-400";
  if (isToday(date)) return "text-amber-600 dark:text-amber-400";
  return "text-muted-foreground";
}

export function bytes(n) {
  if (!n) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let v = n;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

export function initials(name) {
  if (!name) return "";
  return name
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
